// extracted by mini-css-extract-plugin
export default {"authorization":"Authorization_authorization__9ZpJC"};